import type { ApiClient, IApiJsonRequest } from '../../ApiClient';
import type {
  IApiCrowdAddBadgesRequestBody,
  IApiCrowdAddBadgesResponseBody,
  IApiCrowdGeoSearchRequestBody,
  IApiCrowdGeoSearchResponseBody,
  IApiCrowdNotifyRequestBody,
  IApiCrowdNotifyResponseBody,
  IApiCrowdRemoveBadgesRequestBody,
  IApiCrowdRemoveBadgesResponseBody,
  IApiCrowdSearchRequestBody,
  IApiCrowdSearchResponseBody,
} from './CrowdApi.types';

export class CrowdApi {
  public constructor(private client: ApiClient) {}

  public async search(
    appId: string,
    params?: IApiCrowdSearchRequestBody,
  ): Promise<IApiCrowdSearchResponseBody> {
    const request: IApiJsonRequest<IApiCrowdSearchRequestBody> = {
      method: 'get',
      path: '/admin/crowd/search',
      params,
    };

    const data =
      await this.client.fetchJsonStandardized<IApiCrowdSearchResponseBody>(
        request,
        { appId },
      );

    return data;
  }

  public async geoSearch(
    appId: string,
    params?: IApiCrowdGeoSearchRequestBody,
  ): Promise<IApiCrowdGeoSearchResponseBody> {
    const request: IApiJsonRequest<IApiCrowdGeoSearchRequestBody> = {
      method: 'get',
      path: '/admin/crowd/search.geojson',
      params,
    };

    const data =
      await this.client.fetchJsonStandardized<IApiCrowdGeoSearchResponseBody>(
        request,
        { appId },
      );

    return data;
  }

  public async notify(
    appId: string,
    body: IApiCrowdNotifyRequestBody,
  ): Promise<IApiCrowdNotifyResponseBody> {
    const request: IApiJsonRequest<IApiCrowdNotifyRequestBody> = {
      method: 'post',
      path: '/admin/crowd/notify',
      body,
    };

    const data =
      await this.client.fetchJsonStandardized<IApiCrowdNotifyResponseBody>(
        request,
        { appId },
      );

    return data;
  }

  public async addBadges(
    appId: string,
    body: IApiCrowdAddBadgesRequestBody,
  ): Promise<IApiCrowdAddBadgesResponseBody> {
    const request: IApiJsonRequest<IApiCrowdAddBadgesRequestBody> = {
      method: 'post',
      path: '/admin/crowd/addBadges',
      body,
    };

    const data =
      await this.client.fetchJsonStandardized<IApiCrowdAddBadgesResponseBody>(
        request,
        { appId },
      );

    return data;
  }

  public async removeBadges(
    appId: string,
    body: IApiCrowdRemoveBadgesRequestBody,
  ): Promise<IApiCrowdRemoveBadgesResponseBody> {
    const request: IApiJsonRequest<IApiCrowdRemoveBadgesRequestBody> = {
      method: 'post',
      path: '/admin/crowd/delBadges',
      body,
    };

    const data =
      await this.client.fetchJsonStandardized<IApiCrowdRemoveBadgesResponseBody>(
        request,
        { appId },
      );

    return data;
  }
}
